import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { changeTheme, localFetch } from "@/utils/util";
import { UI_THEMES } from "@/utils/const";
import Menu from "primevue/menu";
import Button from "primevue/button";
import { MenuPt as _MenuPt } from "@/utils/globalPassThrough";
export default {
  name: "ThemeSelector",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {
    Button: Button,
    Menu: Menu
  },
  methods: {
    localFetch: localFetch,
    setTheme: function setTheme(theme) {
      changeTheme(theme);
      this.$store.commit("uiConfigStore/setCurrentTheme", theme);
    },
    toggleMenu: function toggleMenu(event) {
      this.$refs.menu.toggle(event);
    }
  },
  computed: {
    MenuPt: function MenuPt() {
      return _MenuPt;
    },
    selectedThemeOption: function selectedThemeOption() {
      var saved = localFetch("saved_ui_theme") || UI_THEMES.SYSTEM;
      return this.options.find(function (o) {
        return o.value === saved;
      });
    }
  },
  data: function data() {
    return {
      options: [{
        icon: "pi pi-sun",
        label: this.$tf("profile.colorScheme.light|Világos"),
        value: UI_THEMES.LIGHT
      }, {
        icon: "pi pi-moon",
        label: this.$tf("profile.colorScheme.dark|Sötét"),
        value: UI_THEMES.DARK
      }, {
        icon: "pi pi-cog",
        label: this.$tf("profile.colorScheme.system|Rendszerbeállítás"),
        value: UI_THEMES.SYSTEM
      }]
    };
  }
};